import React, { useState } from 'react'
import {
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Stack,
} from '@mui/material'
import { MdWhatsapp } from 'react-icons/md'
import useNotification from './common/Notification'
import axios from 'axios'

const SendWhatsapp = () => {
  const showNotification = useNotification()

  const templates = [
    {
      id: '1',
      name: 'balkrishna_test',
      content:
        'Good Morning {name}, \nThis is a testing message.\nThank You Vibhum Software',
    },
    {
      id: '2',
      name: 'vibhum_testing_bk',
      content: 'Hello',
    },
  ]

  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [editedContent, setEditedContent] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [userName, setUserName] = useState('')
  const [accessToken] = useState(
    'EAAUThQCYxHUBO9OrlWn9UfieH5Gg4V8AKCx9OODLWhEyIHnlKFlYxeU9K5DJAsfS3FgQV5uoby4643ZA7RUUwRA674qbbXZCZA1EC1WhzIFEu03MBSNuIQKe3aqW8U0L6ghsuRrqWGY3wc4hEWZAnrNZB3HyoTdx0ntgbPms5ecNy2rdEFIJ2zC0cytexIGRXdc7GYZB1yaMO3BcqP9mteL60L4rOvvEwgrKLENsz4ZABEZD',
  )

  const handleTemplateChange = (e) => {
    const selectedId = e.target.value
    const template = templates.find((t) => t.id === selectedId)
    if (template) {
      setSelectedTemplate(template)
      setEditedContent(template.content.replace('{name}', userName || ''))
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === 'phone_number') {
      setPhoneNumber(value)
    } else if (name === 'name') {
      setUserName(value)
      if (selectedTemplate) {
        setEditedContent(selectedTemplate.content.replace('{name}', value))
      }
    }
  }

  const sendMessage = async (e) => {
    e.preventDefault()

    if (!phoneNumber || !userName || !selectedTemplate) {
      showNotification('Please enter valid data!', 'warning')
      return
    }

    const apiUrl = ` https://graph.facebook.com/v21.0/588859094309242/messages` // Ensure this ID is correct

    const requestBody = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: phoneNumber,
      type: 'template',
      template: {
        name: selectedTemplate.name,
        language: {
          code: 'en',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                parameter_name: 'name',
                text: userName,
              },
            ],
          },
        ],
      },
    }

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Ensure this token is valid
          'Content-Type': 'application/json',
        },
      })

      setTimeout(() => {
        showNotification('WhatsApp message sent successfully!', 'success')
      }, 1000)
    } catch (error) {
      console.error('Error:', error.response?.data || error.message)
      showNotification(
        `Failed to send WhatsApp message: ${
          error.response?.data?.error?.message || 'Unknown error'
        }`,
        'error',
      )
    }
  }

  return (
    <Box
      sx={{
        marginTop: '4rem',
        '@media(max-width:768px)': {
          marginTop: '3rem',
          marginLeft: -10,
          marginRight: -2,
        },
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          textAlign: 'center',
          flexGrow: 1,
          letterSpacing: '2px',
          color: 'primary.main',
          '@media(max-width:768px)': {
            fontSize: '23px',
            marginBottom: -2,
          },
        }}
      >
        Send WhatsApp
      </Typography>

      <Container maxWidth="md">
        <FormControl fullWidth sx={{ mt: 4, mb: 4 }}>
          <InputLabel>Select a Template</InputLabel>
          <Select
            label="Select a Template"
            value={selectedTemplate ? selectedTemplate.id : ''}
            onChange={handleTemplateChange}
          >
            {templates.map((template) => (
              <MenuItem key={template.id} value={template.id}>
                {template.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedTemplate && (
          <Box
            sx={{
              marginTop: 3,
              padding: 3,
              boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
              borderRadius: '5px',
              '@media(max-width:768px)': {
                marginTop: 3,
                padding: 1,
              },
            }}
          >
            <TextField
              variant="outlined"
              fullWidth
              value={editedContent}
              disabled
              multiline
              label="Message Content"
              rows={3}
              sx={{
                width: '100%',
                '@media (max-width: 768px)': {
                  width: '100%',
                },
              }}
              InputProps={{
                sx: {
                  fontSize: '1.3rem',
                  textAlign: 'center',
                  lineHeight: 1.5,
                  '@media (max-width: 768px)': {
                    fontSize: '1rem',
                  },
                },
              }}
            />

            <form onSubmit={sendMessage}>
              <Stack spacing={2} mt={3}>
                <TextField
                  fullWidth
                  label="Enter Customer Name"
                  name="name"
                  value={userName}
                  onChange={handleInputChange}
                  required
                />
                <TextField
                  fullWidth
                  label="Enter Phone Number"
                  name="phone_number"
                  value={phoneNumber}
                  onChange={handleInputChange}
                  required
                />
              </Stack>

              <Box spacing={2} mt={3}>
                <Button
                  // onClick={sendMessage}
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                  sx={{
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    fontSize: '1rem',
                  }}
                >
                  Send WHATSAPP <MdWhatsapp fontSize={25} />
                </Button>
              </Box>
            </form>
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default SendWhatsapp
